export const costCenterConstants = {
  API_INSERT: '/api/costCenter/insert',
  API_UPDATE: '/api/costCenter/update',
  API_DELETE: '/api/costCenter/delete',
  API_GET: '/api/costCenter/',
  API_GETALL: '/api/costCenter/getall',

  INSERT_REQUEST: 'COSTCENTER_INSERT_REQUEST',
  INSERT_SUCCESS: 'COSTCENTER_INSERT_SUCCESS',
  INSERT_FAILURE: 'COSTCENTER_INSERT_FAILURE',

  UPDATE_REQUEST: 'COSTCENTER_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'COSTCENTER_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'COSTCENTER_UPDATE_FAILURE',

  DELETE_REQUEST: 'COSTCENTER_DELETE_REQUEST',
  DELETE_SUCCESS: 'COSTCENTER_DELETE_SUCCESS',
  DELETE_FAILURE: 'COSTCENTER_DELETE_FAILURE',

  GET_REQUEST: 'COSTCENTER_GET_REQUEST',
  GET_SUCCESS: 'COSTCENTER_GET_SUCCESS',
  GET_FAILURE: 'COSTCENTER_GET_FAILURE',

  GETALL_REQUEST: 'COSTCENTER_GETALL_REQUEST',
  GETALL_SUCCESS: 'COSTCENTER_GETALL_SUCCESS',
  GETALL_FAILURE: 'COSTCENTER_GETALL_FAILURE',

  RESET: 'COSTCENTER_RESET',
  SERVICE: 'COSTCENTER_SERVICE',
};
